export const maxHotelTravellerCount = 9
